import React from "react";
import "./NoFooterModal.scss";
import Cross from "sushiweb/Icons/all/Cross";

const NoFooterModal = (props) => {
  const { header, heading, subHeading, handleClose, id } = props;
  const handleClick = (e, event) => {
    if (event === "blur") {
      e.stopPropagation();
    } else {
      handleClose();
    }
  };
  return (
    <section
      onClick={(e) => handleClick(e, "close")}
      className="no-footer-dialog"
    >
      <div
        id={id}
        onClick={(e) => handleClick(e, "blur")}
        className="no-footer-modal"
      >
        {header && (
          <div className="dialog-header flex items-center justify-between">
            <div className="info">
              <h2 className="heading">{heading}</h2>
              <p className="subHeading">{subHeading}</p>
            </div>
            <Cross size={30} showPointer={true} onClick={handleClose} />
          </div>
        )}
        <div className="modal-content">{props.children}</div>
        <div className="modal-btns">{props.modalButtons}</div>
      </div>
    </section>
  );
};

export default NoFooterModal;
